import { render, staticRenderFns } from "./DdCheckSG.vue?vue&type=template&id=c76b1a18&scoped=true&"
import script from "./DdCheckSG.vue?vue&type=script&lang=js&"
export * from "./DdCheckSG.vue?vue&type=script&lang=js&"
import style0 from "./DdCheckSG.vue?vue&type=style&index=0&id=c76b1a18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76b1a18",
  null
  
)

export default component.exports